import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/public/HomePage';
import NotInvitedPage from './pages/public/NotInvitedPage';
import AgendaPage from './pages/public/AgendaPage';
import SpeakersPage from './pages/public/SpeakersPage';
import RsvpPage from './pages/public/RsvpPage';
import MealsPage from './pages/public/MealsPage';
import RegisterPage from './pages/public/RegisterPage';
import FaqPage from './pages/public/FaqPage';
import PollPage from './pages/public/PollPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminEditors from './pages/admin/AdminEditors';
import AdminMeals from './pages/admin/AdminMeals';
import AdminRegister from './pages/admin/AdminRegister';
import AdminPoll from './pages/admin/AdminPoll';
import AdminTeams from './pages/admin/AdminTeams';
import RequireAdmin from './components/RequireAdmin';
import RequireAuth from './components/RequireAuth';

export default function App() {
  return (
    <RequireAuth>
    <Layout>
      <Routes>
        <Route path="/not-invited" element={<NotInvitedPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/agenda" element={<AgendaPage />} />
        <Route path="/speakers" element={<SpeakersPage />} />
        <Route path="/rsvp" element={<RsvpPage />} />
        <Route path="/meals" element={<MealsPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/poll" element={<PollPage />} />
        <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
        <Route path="/admin/editors" element={<RequireAdmin><AdminEditors /></RequireAdmin>} />
        <Route path="/admin/meals" element={<RequireAdmin><AdminMeals /></RequireAdmin>} />
        <Route path="/admin/register" element={<RequireAdmin><AdminRegister /></RequireAdmin>} />
        <Route path="/admin/poll" element={<RequireAdmin><AdminPoll /></RequireAdmin>} />
        <Route path="/admin/teams" element={<RequireAdmin><AdminTeams /></RequireAdmin>} />
      </Routes>
    </Layout>
    </RequireAuth>
  );
}
